import { BrowserRouter, Switch } from 'react-router-dom';
import Route, { RouteProps, RouteAccess } from './Route';
import { MainLayout, Spinner } from 'view/components/layout';
import { useAuthToken } from 'view/hooks';
import {
    LoginPage,
    RegisterAccountPage,
    VerifyEmailPage,
    ForgotPasswordPage,
    ResetPasswordPage,
    DashboardPage,
    MortgageApplicationPage,
    Underwriting,
    CreditPull,
    Profile,
    AdditionalInfo
} from 'view/pages';
import ScrollToTop from 'ScrollToTop';

enum RoutePath {
    // TODO admin & underwriting pages
    application = '/application',
    dashboard = '/dashboard',
    underwriting = '/underwriting',
    creditpull = '/credit-pull',
    additionalInfo = '/additional-info',
    additionalDoc = '/additional-doc',
    verify = '/mg-login',
    reset = '/reset-password',
    forgot = '/forgot-password',
    register = '/register',
    login = '/login',
    profile = '/profile',
    root = '/'
}

const routes: Array<RouteProps> = [
    {
        path: RoutePath.application,
        access: RouteAccess.private,
        layout: MainLayout,
        component: MortgageApplicationPage
    },

    {
        path: RoutePath.dashboard,
        access: RouteAccess.private,
        layout: MainLayout,
        component: DashboardPage
    },

    {
        path: RoutePath.underwriting,
        access: RouteAccess.private,
        layout: MainLayout,
        component: Underwriting
    },

    {
        path: RoutePath.creditpull,
        access: RouteAccess.private,
        layout: MainLayout,
        component: CreditPull
    },

    {
        path: RoutePath.additionalInfo,
        access: RouteAccess.private,
        layout: MainLayout,
        component: AdditionalInfo
    },

    {
        path: RoutePath.additionalDoc,
        access: RouteAccess.private,
        layout: MainLayout,
        component: AdditionalInfo
    },

    {
        path: RoutePath.profile,
        access: RouteAccess.private,
        layout: MainLayout,
        component: Profile
    },

    {
        path: RoutePath.verify,
        access: RouteAccess.protected,
        layout: MainLayout,
        component: VerifyEmailPage
    },

    {
        path: RoutePath.reset,
        access: RouteAccess.public,
        layout: MainLayout,
        component: ResetPasswordPage
    },

    {
        path: RoutePath.forgot,
        access: RouteAccess.public,
        layout: MainLayout,
        component: ForgotPasswordPage
    },

    {
        path: RoutePath.register,
        access: RouteAccess.public,
        layout: MainLayout,
        component: RegisterAccountPage
    },

    {
        path: RoutePath.login,
        access: RouteAccess.public,
        layout: MainLayout,
        component: LoginPage
    },

    {
        path: RoutePath.root,
        access: RouteAccess.redirect,
        component: () => (<></>)
    }
];

const AppRouter: React.FunctionComponent = () => {
    const loading = useAuthToken();

    if (loading) {
        return (
            <MainLayout>
                <Spinner />
            </MainLayout>
        );
    }

    return (
        <BrowserRouter>
            <ScrollToTop />
            <Switch>
                {
                    routes.map(({ path, access, component, ...props }: RouteProps) => {
                        return (
                            <Route
                                key={path}
                                path={path}
                                access={access}
                                component={component}
                                {...props}
                            />
                        );
                    })
                }
            </Switch>
        </BrowserRouter>
    );
};

export default AppRouter;
